/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdministrationUserDetails } from '../../models/administration-user-details';
import { KeyType } from '../../models/key-type';

export interface GetAdministrationOrganizationSiteUser$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The user key
 */
  userKey: KeyType;
}

export function getAdministrationOrganizationSiteUser(http: HttpClient, rootUrl: string, params: GetAdministrationOrganizationSiteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrationUserDetails>> {
  const rb = new RequestBuilder(rootUrl, getAdministrationOrganizationSiteUser.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('userKey', params.userKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdministrationUserDetails>;
    })
  );
}

getAdministrationOrganizationSiteUser.PATH = '/administration/organization-sites/{organizationSiteKey}/users/{userKey}';
